import { TESTIMONIALS } from "@/constants/landing";
import { Quote } from "lucide-react";

export default function Testimonials() {
  return (
    <section id="work" className="py-20 sm:py-28 relative" data-testid="testimonials-section">
      <div className="max-w-[1240px] mx-auto px-5 sm:px-8">
        <div className="max-w-[640px] mb-10 sm:mb-14">
          <span className="yg-eyebrow">// Signal</span>
          <h2 className="yg-h2 text-[clamp(30px,4.6vw,52px)] mt-3 text-white">
            Operators talk.
            <br />
            <span className="text-[var(--yg-violet-light)]">We build.</span>
          </h2>
        </div>

        {/* Mobile horizontal scroll · Desktop grid */}
        <div className="md:hidden -mx-5">
          <div className="flex gap-3 overflow-x-auto no-scrollbar snap-x snap-mandatory px-5 pb-3" data-testid="testimonials-scroll-mobile">
            {TESTIMONIALS.map((t, i) => (
              <figure
                key={t.name}
                className="yg-card shrink-0 snap-start w-[85%] p-5 flex flex-col justify-between min-h-[220px]"
                data-testid={`testimonial-m-${i}`}
              >
                <Quote className="w-5 h-5 text-[var(--yg-violet-light)] mb-3" />
                <blockquote className="text-[14.5px] leading-[1.55] text-white tracking-[-0.005em]">
                  &ldquo;{t.quote}&rdquo;
                </blockquote>
                <figcaption className="mt-4 pt-4 border-t border-[var(--yg-border)]">
                  <div className="text-white font-semibold text-[13px]">{t.name}</div>
                  <div className="yg-mono text-[10px] tracking-[0.2em] uppercase text-[var(--yg-text-dim)] mt-1">{t.role}</div>
                </figcaption>
              </figure>
            ))}
          </div>
          <div className="px-5 mt-1 flex items-center justify-between text-[10.5px] yg-mono uppercase tracking-[0.2em] text-[var(--yg-text-dim)]">
            <span>Swipe →</span>
            <span>{TESTIMONIALS.length} operators</span>
          </div>
        </div>

        <div className="hidden md:grid md:grid-cols-3 gap-4 sm:gap-5">
          {TESTIMONIALS.map((t, i) => (
            <figure
              key={t.name}
              className="yg-card p-6 sm:p-7 flex flex-col justify-between min-h-[240px]"
              data-testid={`testimonial-${i}`}
              style={{ animation: `yg-rise 700ms ${i * 100}ms both cubic-bezier(.2,.9,.3,1)` }}
            >
              <Quote className="w-6 h-6 text-[var(--yg-violet-light)] mb-4" />
              <blockquote className="text-[15.5px] leading-[1.55] text-white tracking-[-0.005em]">
                &ldquo;{t.quote}&rdquo;
              </blockquote>
              <figcaption className="mt-6 pt-5 border-t border-[var(--yg-border)]">
                <div className="text-white font-semibold text-[13.5px]">{t.name}</div>
                <div className="yg-mono text-[10px] tracking-[0.2em] uppercase text-[var(--yg-text-dim)] mt-1">{t.role}</div>
              </figcaption>
            </figure>
          ))}
        </div>

        {/* Logo marquee */}
        <div className="mt-16 sm:mt-20 relative overflow-hidden">
          <div className="yg-mono text-[10px] tracking-[0.28em] uppercase text-[var(--yg-text-dim)] text-center mb-6">
            Powering ops across
          </div>
          <div className="relative">
            <div className="yg-marquee">
              {[...Array(2)].map((_, dup) => (
                <div key={dup} className="flex items-center gap-12 pr-12">
                  {["Aura Clinics", "Hexa Realty", "Vroom Autos", "Sage Coaching", "Cove Hotels", "Byte Retail", "Nexa Finance", "Flame Foods"].map(name => (
                    <span key={name+dup} className="text-[15px] font-extrabold tracking-[-0.02em] text-white/25 hover:text-white/60 transition-colors whitespace-nowrap">
                      {name}
                    </span>
                  ))}
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
